export default __webpack_public_path__ + "static/UI-UX-18ce913235ccfdcdbf77695978f40667.png";